<div class="p-3 rounded-3">
  <div class="row mb-2">
    <div class="col-12 mb-3">
      <div class="titletoptables">
        <div class="leftsideicons">
          <img src="../../assets/image/error-log.png" alt="error-log" onkeydown="" />
        </div>
        <h3>{{ "Error Logs" }}</h3>
      </div>
    </div>
  </div>
  <div class="grid-card">
    <div class="filters-bar">
      <div class="filter-search">
        <app-search-input [value]="searchString" (valueChange)="filterData($event)" (cleared)="clearList()"></app-search-input>
      </div>
    </div>
    <app-data-grid>
    <kendo-grid #grid [loading]='kendoLoading' [data]="gridData" [filter]="state.filter" [sortable]="{mode: 'single'}"
      [columnMenu]="{ filter: true }" [pageSize]="state.take" [skip]="state.skip"
      (columnVisibilityChange)="onColumnVisibilityChange(grid)"
      [pageable]="gridData?.data?.length && gridData.data.length > 0 ? pageableWithAll : false" [sort]="sort"
      (sortChange)="gridData ? sortChange($event): null" [resizable]="true" [reorderable]="true" filterable="menu"
      [filter]="state.filter" [selectable]="true" (dataStateChange)="gridData ? dataStateChange($event): null"
      [groupable]="true" [group]="state.group" [navigable]="true" [height]="gridHeight">
      <kendo-grid-column field="" title=" " [includeInChooser]="false" [width]="40" [sortable]="false" [filterable]="false" [columnMenu]="false" [groupable]="false"
        headerClass="col-action" class="col-action">
        <ng-template kendoGridCellTemplate let-dataItem>
          <div class="text-center">
            <div class="mx-2 d-inline-block">
              <button type="button" class="verical_menu" (click)="openDialogWithTemplateRef(detailPage, dataItem)" matTooltip="View">
                <kendo-svg-icon [icon]="icons.view"></kendo-svg-icon>
              </button>
            </div>
          </div>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="Message" title="Message" [width]='400'>
      </kendo-grid-column>
      <kendo-grid-column field="Source" title="Source" [width]='200'>
      </kendo-grid-column>
      <kendo-grid-column field="User" title="User" [width]='150'>
      </kendo-grid-column>
      <kendo-grid-column field="TimeUtc" title="Date" filter="date" format="dd-MM-yyyy" [width]='150'>
      </kendo-grid-column>
    </kendo-grid>
    </app-data-grid>
  </div>
</div>
<ng-template #detailPage>
  <div class="modal-dialog">
    <div class="modal-content">
      <!-- Header -->
      <div class="modal-header">
        <h4 class="popup-title">
          Error Detail Page
        </h4>
        <button type="button" class="btn-close" aria-label="Close" (click)="closeDialog()">
        </button>
      </div>
      <!-- Body -->
      <div class="modal-body">
        <mat-dialog-content>
          <div class="row mt-2">
            <div class="col-2">
              <label><b>Message:</b></label>
            </div>
            <div class="col-10">
              <label>{{ selectdErrorData.Message }}</label>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-2">
              <label><b>Source:</b></label>
            </div>
            <div class="col-10">
              <label>{{ selectdErrorData.Source }}</label>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-2">
              <label><b>User:</b></label>
            </div>
            <div class="col-10">
              <label>{{ selectdErrorData.User }}</label>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-2">
              <label><b>Date:</b></label>
            </div>
            <div class="col-10">
              <label>{{ selectdErrorData.TimeUtc | date: 'dd-MM-yyyy' }}</label>
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-2">
              <label><b>AllXml:</b></label>
            </div>
            <div class="col-10">
              <textarea matInput readonly rows="10" class="error-xml-box">{{ selectdErrorData.AllXml }}</textarea>
            </div>
          </div>
        </mat-dialog-content>

        <!-- Footer -->
        <mat-dialog-actions align="end">
          <button type="button" mat-raised-button class="btn btn-secondary" (click)="closeDialog()">
            Close
          </button>
        </mat-dialog-actions>

      </div>
    </div>
  </div>
</ng-template>